import { useRef, useState, useEffect } from 'react';

export const useEndOfText = () => {
  const node = useRef<HTMLDivElement | null>(null);
  const [isEndOfText, setIsEndOfText] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const { scrollHeight, scrollTop, clientHeight } = node?.current || {};
      const isEnd =
        scrollHeight !== undefined &&
        Math.abs((scrollTop ?? 0) + (clientHeight ?? 0) - scrollHeight) < 1;

      setIsEndOfText(isEnd);
    };

    setTimeout(() => {
      if (node.current) {
        node.current.addEventListener('scroll', handleScroll);
      }
    }, 200);

    return () => {
      if (node.current) {
        node.current.removeEventListener('scroll', handleScroll);
      }
    };
  });

  return { isEndOfText, setIsEndOfText, node };
};
